import React from 'react';
import PropTypes from "prop-types";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles({
    root: {
        marginTop: "15px",
        marginBottom: "25px"
    },
    cardInActivo: {
        width: 345,
        height: "240px",
        marginTop: "30px",
        boxShadow: "0px 2px 1px -1px rgba(255, 1, 200, 0.89), 0px 1px 1px 0px rgba(255, 1, 200, 0.89), 0px 1px 3px 0px rgba(255, 1, 200, 0.89);"
    },
    cardActivo: {
        width: 345,
        height: "240px",
        marginTop: "30px",
        boxShadow: "0px 2px 1px -1px rgba(1, 255, 1, 0.89), 0px 1px 1px 0px rgba(1, 255, 1, 0.89), 0px 1px 3px 0px rgba(1, 255, 1, 0.89);"
    },
    media: {
        height: "130px",
        width: "99%",
        backgroundSize: "contain",
        padding: "3px"
    },
    inputElementLeft: {
        textAlign: "start",
        cursor: "auto"
    }
    ,
    inputElementRight: {
        textAlign: "end",
        cursor: "auto"
    }
});
//#endregion

function articulo_desc({ articulo, tickets, ticketsSugeridos, stock, isActivo }) {

    const classes = useStyles();

    let fotoName = 'miniSinFoto';

    if(articulo.articuloCompraFoto.length !== 0){
        const predeterminada = articulo.articuloCompraFoto.find(f => f.bPredeterminada === true);
        if(predeterminada) fotoName = predeterminada.fotoId;
    }

    //const fotoName = articulo.articuloCompraFoto.length !== 0 ? articulo.articuloCompraFoto.find(f => f.bPredeterminada === true).fotoId : 'miniSinFoto';

    return (
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            className={classes.root}
        >
            <Grid container
                direction="row"
                justify="flex-start"
                alignItems="center" spacing={2} item xs={8} >
                <Grid item xs={12}>
                    <Typography color="primary" variant="h5">
                        {articulo.descr}
                    </Typography>
                </Grid>
                <Grid item xs={11} >
                    <TextField
                        autoFocus
                        fullWidth
                        id="outlined-read-only-input-descp"
                        label="Descripción pública"
                        defaultValue={articulo.descrPublica}
                        InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={11} >
                    <TextField
                        fullWidth
                        id="outlined-read-only-input-descpri"
                        label="Descripción privada"
                        defaultValue={articulo.descrPrivada}
                        InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6} >
                    <TextField
                        id="outlined-read-only-input-fami"
                        label="Familia"
                        defaultValue={articulo.iSubfamiliaNavigation ? articulo.iSubfamiliaNavigation.iFamiliaNavigation ? articulo.iSubfamiliaNavigation.iFamiliaNavigation.descr : '' : ''}
                        InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6} >
                    <TextField
                        id="outlined-read-only-input-subfami"
                        label="SubFamilia"
                        defaultValue={articulo.iSubfamiliaNavigation ? articulo.iSubfamiliaNavigation.descr: ''}
                        InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={11} >
                    <hr style={{ border: "1px solid gray" }} />
                </Grid>
                <Grid item xs={6} >
                    <TextField
                        id="outlined-read-only-input-falta"
                        label="Fecha alta"
                        defaultValue={(articulo.fAlta ?
                            new Date(articulo.fAlta).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' })
                            : '')}
                        InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6} >
                    <TextField
                        id="outlined-read-only-input-ultpre"
                        label="Ult. precio compra"
                        defaultValue={articulo.ultPrecio}
                        InputProps={{ classes: { input: classes.inputElementRight }, readOnly: true }}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6} >
                    <TextField
                        id="outlined-read-only-input-fbaja"
                        label="Fecha baja"
                        defaultValue={(articulo.fBaja ?
                            new Date(articulo.fBaja).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' })
                            : 'Sin fecha baja')}
                        InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={6} >
                    <TextField
                        id="outlined-read-only-input-ultfec"
                        label="Ult. fecha compra"
                        defaultValue={articulo.dcPedidoLinea.length > 0 ? new Date(articulo.dcPedidoLinea[0].pedido.fDoc).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric' }) : 'Sin última fecha compra'}
                        InputProps={{ classes: { input: classes.inputElementLeft }, readOnly: true }}
                        variant="outlined"
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2} item xs={4}>
                <Card className={isActivo ? classes.cardActivo : classes.cardInActivo}>
                    {isActivo ?
                        <Grid container direction="row" justify="center" alignItems="center" style={{ padding: "5px", marginTop: "10px" }}>
                            <DoneOutlineIcon color="primary" fontSize="medium" />
                            <Typography color="primary" component="p">
                                Activo
                            </Typography>
                        </Grid>
                        : <Grid container direction="row" justify="center" alignItems="center" style={{ padding: "5px", marginTop: "10px" }}>
                            <CancelIcon color="secondary" fontSize="medium" />
                            <Typography color="secondary" component="p">
                                Inactivo
                            </Typography>
                        </Grid>}

                    <CardActionArea>
                        <CardMedia
                            className={classes.media}
                            style={{ backgroundPositionY: "0%" }}
                            image={`https://neuriteilusiona.blob.core.windows.net/fotos/${fotoName}`}
                            title={articulo.descr}
                        />
                    </CardActionArea>

                    <Grid container direction="row" justify="center" alignItems="center" style={{ padding: "5px" }}>
                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={articulo.bClienteVisible} />}
                            label={
                                <label align="justify" className="mb-0">
                                    Visible cliente
                    </label>
                            }
                        />
                    </Grid>
                </Card>
                <Grid container direction="row" spacing={2}
                    style={{ paddingBottom: "20px", marginTop: "40px" }}>

                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            id="outlined-read-only-input-point"
                            label="Nº tickets"
                            defaultValue={tickets}
                            InputProps={{ classes: { input: classes.inputElementRight }, readOnly: true }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            id="outlined-read-only-input-pointt"
                            label="Nº tickets sugeridos"
                            defaultValue={ticketsSugeridos}
                            InputProps={{ classes: { input: classes.inputElementRight }, readOnly: true }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            id="outlined-read-only-input-stock"
                            label="Stock"
                            defaultValue={stock}
                            InputProps={{ classes: { input: classes.inputElementRight }, readOnly: true }}
                            variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={6}>

                        <FormControlLabel
                            control={<Checkbox color="primary"
                                checked={articulo.bSegstock} />}
                            label={
                                <label align="justify" className="mb-0">
                                    Seguimiento stock
                    </label>
                            }
                        />
                    </Grid>
                </Grid>

            </Grid>
        </Grid>
    );
}

export default articulo_desc;

articulo_desc.propTypes = {
    gift: PropTypes.shape({
        name: PropTypes.string,
        image: PropTypes.string,
        points: PropTypes.number,
        stock: PropTypes.number,
    }),
    onClick: PropTypes.func,
    options: PropTypes.object
};